/* @flow */
import * as React from 'react';
import ChatStreamContainer from './ChatStreamContainer';
import { Stream, StreamContext, CTX_CHAT_STREAM, StreamPlaceholder } from 'chat/components/Stream';

type Props = {
  uuid: string,
  onScrollToBottom?: () => void,
};

export class ChatStreamPlaceholder extends React.Component<*, *> {
  render() {
    return <StreamPlaceholder />;
  }
}

class ChatStream extends React.Component<Props, void> {
  stream: Stream;

  handleNewBottomItem = () => {
    if (this.stream) {
      this.stream.scrollToBottom();
    }
  };

  render() {
    return (
      <StreamContext.Provider value={CTX_CHAT_STREAM}>
        <ChatStreamContainer uuid={this.props.uuid} onNewBottomItem={this.handleNewBottomItem}>
          {props => (
            <Stream
              {...props}
              uuid={this.props.uuid}
              ref={(e: any) => (this.stream = e)}
              onScrollToBottom={this.props.onScrollToBottom}
            />
          )}
        </ChatStreamContainer>
      </StreamContext.Provider>
    );
  }
}

export { ChatStream };
export default ChatStream;
